import MainPage from "../containers/MainPage";


let indexRoutes = [{
  path: "/patient_programs", component: MainPage, exact: true
}];

export default indexRoutes;
